<div class="initial-load-overlay" *ngIf="isLoading"></div>
